<template>
    <div class="banner">
        <img class="banner_pc" src="http://wx3.sinaimg.cn/large/0067mezugy1fxuzefmj04j31ig0iw4ek.jpg" />
        <img class="banner_mbl" src="http://wx1.sinaimg.cn/large/0067mezugy1g5q46kbs5kj30ku0vi750.jpg" />
        <div class="position">
            <h1>全球招商合作</h1>
            <p class="p1">Global investment cooperation</p>
            <ul>
                <li>
                    <p class="p2">代理经销</p>
                    <p class="p3">Agent distribution</p>
                </li>
                <li>
                    <p class="p2">KA连锁</p>
                    <p class="p3">KA chain</p>
                </li>
                <li>
                    <p class="p2">跨境业务</p>
                    <p class="p3">Cross-border business</p>
                </li>
                <li>
                    <p class="p2">礼品定制</p>
                    <p class="p3">Customized gifts</p>
                </li>
            </ul>
            <p class="p4" @click="pageSwitch()"><router-link :to="{path: '/business/contact'}" tag="span">点击联系我们》</router-link></p>
        </div>
        
    </div>
</template>
<script>
    export default{
        data(){
            return {

            }
        },
        methods:{
            pageSwitch() {
                this.$emit("pageSwitch");
            }
        }
    }
</script>
<style scoped>
.banner{
    /* height: 1000px;
    background: url(http://wx3.sinaimg.cn/large/0067mezugy1fxuzefmj04j31ig0iw4ek.jpg) no-repeat; */
    background-size: auto 100%;
    background-position: center;
    color: #ffffff;
    text-align: center;
    overflow: hidden;
    margin-top: 0px;
}

.banner img{
    width: 100%;
    height: auto;
}

.banner img.banner_mbl{
    display: none;
}

.banner .position{
    position: absolute;
    top: 0px;
    width: 100%;
}

.banner h1{
    font-size: 52px;
    margin-top: 130px;

}
.banner p{
    opacity: 0.7;
    text-transform: uppercase;  
    font-weight: 300;
}
.banner .p1{
    font-size: 18px;
    margin-top: 10px;
}
.banner ul li{
    display: inline-block;
    margin: 40px 3px;
    border: 1px solid rgba(255,255,255, 0.4);
    width: 174px;
    height: 74px;
    margin-bottom: 0px;
}

.banner .p2{
    font-size: 20px;
    opacity: 1;
    margin-top: 8px;
}
.banner .p3{
    font-size: 12px;
    margin-top: 4px;
}

.banner .p4{
    margin-top: 45px;
}

.banner .p4 span{
    font-size: 22px;
    font-weight: lighter;
}

@media (max-width: 768px) {
    .banner{
        height: 23.04rem;
        /* margin-top: 2.56rem; */
        background-image: url(http://wx1.sinaimg.cn/large/0067mezugy1g5q46kbs5kj30ku0vi750.jpg);
        background-size: 100% auto;
        
    }
    .banner img.banner_pc{
    display: none;
}
    .banner h1{
        font-size: 0.9387rem;
        margin-top: 2.56rem;
    }
    .banner .p1{
        font-size: 0.5973rem;
        margin-top: 0.1707rem;
    }
    .banner ul{
        margin-top: 1.28rem;
    }
    .banner ul li{
        width: 7.2533rem;
        height: 2.3893rem;
        margin: 0.256rem;
    }
    .banner ul li .p2{
        font-size: 0.6827rem;
    }
    .banner ul li .p3{
        font-size: 0.512rem;
    }
    .banner .p4{
        margin-top: 0.8533rem;
    }
    .banner .p4 span{
        font-size: 0.6827rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/banner_business.vue